import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheckIcon,
  SparklesIcon,
  KeyIcon,
  Cog6ToothIcon,
  ClipboardDocumentListIcon,
  PhotoIcon, // 🆕 ikon galeri
} from "@heroicons/react/24/solid";

// ✅ Tambah tab baru "galeri"
const tabs = [
  { id: "security", label: "Petugas Security", Icon: ShieldCheckIcon },
  { id: "cleaning", label: "Petugas Cleaning Service", Icon: SparklesIcon },
  { id: "bertugas", label: "Data Akun", Icon: KeyIcon },
  { id: "utama", label: "Kelola Utama", Icon: Cog6ToothIcon },
  { id: "galeri", label: "Galeri", Icon: PhotoIcon }, 
  { id: "catatan", label: "Catatan", Icon: ClipboardDocumentListIcon },
];

export default function AdminSidebar({ activeTab, setActiveTab }) {
  return (
    <aside className="flex h-full w-[260px] flex-col bg-white border-r border-gray-200 shadow-sm">
      {/* Bagian Navigasi */}
      <div className="flex-1 px-4 py-6 overflow-y-auto">
        <nav className="flex flex-col gap-1.5">
          {tabs.map(({ id, label, Icon }) => {
            const isActive = activeTab === id;
            return (
              <motion.button
                key={id}
                onClick={() => setActiveTab(id)}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-all duration-200 
                  ${
                    isActive
                      ? "bg-green-50 font-semibold text-green-700 shadow-inner"
                      : "font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`}
              >
                <Icon className="h-5 w-5" />
                <span>{label}</span>
              </motion.button>
            );
          })}
        </nav>
      </div>

      {/* Footer Sidebar */}
      <div className="p-4 border-t border-gray-100 text-center text-xs text-gray-400">
        © {new Date().getFullYear()} Admin Panel
      </div>
    </aside>
  );
}
